import type { CatalogoDescriptor } from '@next/compartilhados/catalogos'

export type OpcaoEmpregado = Readonly<{
  id: string
  name: string
  code?: string | null
  resignation?: string | null
  closingDate?: number | null
  admission?: string | null
  company?: readonly Readonly<{ id: string, name?: string | null }>[] | null
  funct?: string | null
  sincronizarComRepp?: boolean | null
  customRules?: Readonly<{ id?: string, calculoPassivo?: boolean }> | string | null
  workHourBankRules?: Readonly<{ id: string, name?: string | null, autoCompensate?: boolean, separarCompensacaoEAcumulo?: boolean, mudaNomenclaturaParaCompensacaoNaFolha?: boolean }> | string | null
  firstWorkDay?: string | null
}>

export type FiltrosCatalogoEmpregado = Readonly<{
  id?: readonly string[]
  company?: readonly string[]
}>

export type SelecaoCatalogoEmpregado = OpcaoEmpregado | readonly OpcaoEmpregado[] | null
export type OperacoesCatalogoEmpregado = Readonly<{
  listarOpcoes: (sinal: AbortSignal) => Promise<readonly OpcaoEmpregado[]>
}>

export const DESCRITOR_CATALOGO_EMPREGADO: CatalogoDescriptor<OpcaoEmpregado> = Object.freeze({
  nome: 'empregados',
  versaoProjecao: 5,
  validarItens: (valor: unknown): valor is readonly OpcaoEmpregado[] => (
    Array.isArray(valor) && valor.every(item => typeof item === 'object' && item !== null && !Array.isArray(item)
      && !('phoneclockPassword' in item) && !('phoneclock_password' in item))
  ),
})
